import axios from 'axios'

export class DownloadCustom {
  constructor() {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.getElementById('custom_download_list') === null) return
      let url = new URL(window.location.href)
      let param = url.searchParams.get('id')
      console.log(param)
      axios.get(`/wp-json/wp/v2/custom/book?id=${param}`).then(function (res) {
        let datas = res.data
        const wrap = document.getElementById('custom_download_list')
        wrap.innerHTML = ''
        let elm = ''
        for (let i = 0; i < datas.length; i++) {
          const post = datas[i]
          elm += `<div class="p-contact_body__download__item">
                    <div class="c-button03 -blue"><a href="${post.pdf_src}" target="_blank">ダウンロードする<i><img src="/img/common/ico/arrow-right-solid.svg" class="js-svg c-ico" alt=""></i></a></div>
                    <div class="thumb"><img src="${post.thumb_src}"></div>
                    <div class="text">${post.title}</div>
                  </div>`
        }
        wrap.insertAdjacentHTML('afterbegin', elm)
        deSVG('.js-svg', true)
      })
    })
  }
}
